<template>
  <div class="login-page">
    <div class="login-blob blob-1"></div>
    <div class="login-blob blob-2"></div>

    <div class="login-container reveal">
      <!-- Logo Section -->
      <div class="login-header">
        <div class="logo-mark"><span>P</span></div>
        <h1 class="logo-text">Pro<span>Fissa</span></h1>
        <p class="login-subtitle">Interface d'Administration Sécurisée</p>
      </div>

      <!-- Login Card -->
      <div class="login-card glass">
        <el-alert v-if="errorMessage" :title="errorMessage" type="error" show-icon :closable="false" class="mb-20" />

        <form @submit.prevent="submit" class="login-form">
          <div class="form-group">
            <label>Identifiant (Téléphone)</label>
            <el-input
              v-model="phoneDisplay"
              placeholder="XX XX XX XX"
              size="large"
              :prefix-icon="User"
              maxlength="11"
              @input="onPhoneInput"
            />
          </div>

          <div class="form-group">
            <label>Code d'accès</label>
            <el-input
              v-model="password"
              type="password"
              placeholder="••••••••"
              size="large"
              show-password
              :prefix-icon="Lock"
            />
          </div>

          <el-button
            type="primary"
            native-type="submit"
            :loading="isLoading"
            class="submit-btn"
          >
            {{ isLoading ? 'Authentification...' : 'Accéder au Panel' }}
          </el-button>
        </form>
      </div>

      <div class="login-footer">
        &copy; {{ new Date().getFullYear() }} ProFissa &bull; Accès Restreint
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import { User, Lock } from '@element-plus/icons-vue'

defineProps({
  isLoading:    { type: Boolean, default: false },
  errorMessage: { type: String,  default: '' },
})

const emit = defineEmits(['submit'])

const phoneDisplay = ref('')
const password     = ref('')

const onPhoneInput = (val) => {
  // Keep only digits, limit to 8 (Burkina Faso local number length)
  const digits = val.replace(/\D/g, '').slice(0, 8)
  // Format as XX XX XX XX
  phoneDisplay.value = digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim()
}

const submit = () => {
  const digits = phoneDisplay.value.replace(/\D/g, '')
  if (!digits || !password.value) return
  emit('submit', { phone: digits, password: password.value })
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: var(--bg);
  position: relative;
  overflow: hidden;
}

.login-blob {
  position: absolute;
  width: 500px;
  height: 500px;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.1;
  pointer-events: none;
}
.blob-1 { background: var(--accent); top: -100px; right: -100px; }
.blob-2 { background: var(--primary-light); bottom: -100px; left: -100px; }

.login-container {
  width: 100%;
  max-width: 420px;
  position: relative;
  z-index: 2;
}

.login-header { text-align: center; margin-bottom: 2.5rem; }
.logo-mark {
  width: 60px; height: 60px;
  background: var(--accent);
  border-radius: 18px;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1rem;
  box-shadow: 0 0 30px var(--accent-glow);
}
.logo-mark span { font-family: 'Outfit', sans-serif; font-weight: 900; font-size: 1.75rem; color: #fff; }
.logo-text { font-family: 'Outfit', sans-serif; font-size: 1.8rem; font-weight: 800; letter-spacing: -1px; }
.logo-text span { color: var(--accent); }
.login-subtitle { color: var(--text-dim); font-size: 0.85rem; font-weight: 600; margin-top: 0.5rem; text-transform: uppercase; letter-spacing: 1px; }

.login-card {
  padding: 2.5rem;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(12px);
}

.login-form { display: grid; gap: 1.5rem; }
.form-group { display: flex; flex-direction: column; gap: 0.5rem; }
.form-group label { font-size: 0.75rem; font-weight: 800; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.5px; }

.submit-btn {
  width: 100%;
  height: 50px;
  border-radius: 14px;
  font-family: 'Outfit', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  background: var(--accent);
  border: none;
  box-shadow: 0 0 20px var(--accent-glow);
  transition: all 0.3s ease;
  margin-top: 0.5rem;
}
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 0 35px var(--accent-glow); background: var(--accent); }

.login-footer { text-align: center; margin-top: 2rem; font-size: 0.75rem; color: var(--text-dim); font-weight: 600; letter-spacing: 0.5px; }
.mb-20 { margin-bottom: 20px; }
</style>